import styled from 'styled-components';

export const H1 = styled.h1`
  flex: 1;
  padding: 0;
  margin: 0;
`;

export const Wrapper = styled.div`
  flex: 1;
  height: 50vh;
  border: 3px solid #334;
  position: fixed;
  background-color: black;
  z-index: 999;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  user-select: none;
  right: 0;
  max-width: 700px;
`;

export const Top = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px 12px;
`;

export const Content = styled.div`
  flex: 1;
  max-height: calc(100% - 70px);
  overflow-y: auto;
  box-shadow: inset 0 0 20px 10px rgba(255, 255, 255, 0.03);
  padding: 10px;
`;

export const Actions = styled.div`
  flex: 1;
`;
